// Shared file utility functions to avoid duplication

// Get file extension from URL, handling query parameters
export const getExtensionFromUrl = (url) => {
  if (!url) return '';
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const extension = pathname.split('.').pop()?.toLowerCase();
    return extension || '';
  } catch (error) {
    // Fallback for invalid or relative URLs
    const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
    return extension || '';
  }
};

// Get MIME type from file extension
export const getMimeType = (url) => {
  const extension = getExtensionFromUrl(url);
  const mimeTypes = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'webp': 'image/webp',
    'bmp': 'image/bmp',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'txt': 'text/plain',
    'rtf': 'application/rtf',
    'zip': 'application/zip',
    'rar': 'application/x-rar-compressed',
    'csv': 'text/csv',
    'json': 'application/json',
    'xml': 'application/xml'
  };
  return mimeTypes[extension] || 'application/octet-stream';
};

// Check if file is an image
export const isImageFile = (url) => {
  if (!url) return false;
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
  const extension = getExtensionFromUrl(url);
  return imageExtensions.includes(extension);
};

// Check if file is a PDF
export const isPdfFile = (url) => {
  if (!url) return false;
  return getExtensionFromUrl(url) === 'pdf';
};

// Sanitize filename for safe file operations
export const sanitizeFileName = (fileName) => {
  return fileName.replace(/[^a-zA-Z0-9.-]/g, '_');
};

// Generate unique temporary filename
export const generateTempFileName = (fileName, extension) => {
  const sanitized = sanitizeFileName(fileName);
  return `${new Date().getTime()}-${sanitized}.${extension}`;
}; 